import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import NavBar from "react-bootstrap/NavBar";
import Nav from "react-bootstrap/Nav";
import './App.css';

// Components
import Footer from './Components/Footer';
import HomePage from './Pages/HomePage';
import ProjectsPage from './Pages/ProjectsPage';
import AboutPage from './Pages/AboutPage';
import ContactPage from './Pages/ContactPage';
import StonkBetaPage from './Pages/Stonk-Beta-Page';
import StonkBetaThankYouPage from './Pages/Stonk-Thank-You';

const linkStyle = {
  color: '#2783d9'
};

class App extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {
      color: "#3b3b3b",
      title: 'Stonk App Privacy Policy',
      headerLinks: [
        {title: 'Home', path: '${process.env.PUBLIC_URL}/'},
        {title: 'Projects', path: '${process.env.PUBLIC_URL}/Projects'},
        {title: 'About', path: '${process.env.PUBLIC_URL}/About'},
        {title: 'Contact', path: '${process.env.PUBLIC_URL}/Contact'},
        {title: 'Stonk Beta', path: '${process.env.PUBLIC_URL}/Stonk-Beta'},
        {title: 'Thank you for singing up for the Stonk Beta', path: '${process.env.PUBLIC_URL}/Stonk-Beta-Thank-You'}
      ],
      home: {
        title: 'Stonk App Privacy Policy',
        subTitle: 'Featured Projects'
      },
      projects: {
        title: 'Projects I have Developed'
      },
      about: {
        title: 'About Me'
      },
      contact: {
        title: 'Let\'s Work Together'
      }
    }
  }

  render() {

    const m_style = {
      textAlign: 'center',
      alignSelf: 'stretch'
    };


    return (
      <Router basename={process.env.PUBLIC_URL}>
        <Container className="p-0" fluid={true} style={{backgroundColor: 'Black'}}>
          
          <NavBar className="border-bottom" bg="transparent" expand="md">
            <NavBar.Brand style={{color: 'White'}}>Stonk Privacy Policy</NavBar.Brand>            
          </NavBar>


          <AboutPage />

          <Footer />

        </Container>
      </Router>
    );
  }
}

export default App;
